import React, { useState } from "react";
import CompanyNavbar from "../Components/CompanyNavbar";
import CompanySidebar from "../Components/CompanySidebar";

const CompanyLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      <CompanySidebar isCollapsed={isCollapsed} />
      <div className="flex-1 flex flex-col min-w-0">
        <CompanyNavbar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        <main className="flex-1 p-4 bg-gray-50 overflow-y-auto overflow-x-hidden">
          <div className="w-full max-w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default CompanyLayout;